<template>
  <v-row>
    <v-col class="pa-0 mt-2">
      <v-card class="pa-0">
        <v-row class="d-flex justify-end pr-4">
          <v-col class="pa-0 d-flex align-center pl-8">
            <h3 class="title mb-0">Prêmios</h3>
          </v-col>
          <v-col cols="3">
            <mf-search v-model="prizeSearch" class="text-field--full-row" hide-details placeholder="Busque pelo prêmio" />
          </v-col>
        </v-row>
        <raffle-table
          :items="raffle.prizes"
          :search.sync="prizeSearch"
          :headers="prizesTableHeader"
          :transformFunction="prizeTransformFunction"
          :filterItemsBySearch="prizeFilterItemsBySearch"
        >
          <template v-slot:item="{ item, index }">
            <tr :key="`item-${index}`">
              <td class="table-text--gray">
                <v-tooltip v-model="showTooltipPrizeTitle[item.title]" max-width="250" top content-class="truncated-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ item.title | truncate(60) }}
                    </span>
                  </template>
                  <span>{{ item.title }}</span>
                </v-tooltip>
              </td>
              <td class="table-text--gray">{{ formatedDate(item.raffle_date) }}</td>
              <td class="table-text--gray">{{ item.quantity }}</td>
              <td class="table-text--gray">{{ item.winners.length }}</td>
              <td class="d-flex justify-center align-center">
                <v-tooltip :disabled="hasPiiAccess" max-width="250" top content-class="truncated-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <p :class="linksClassList" class="mb-0" @click="$emit('register_winner', item)">Registrar sorteado</p>
                    </span>
                  </template>
                  <span>Você precisa ter a permissão de acesso a informações privilegiadas para acessar esse recurso.</span>
                </v-tooltip>
              </td>
              <td>
                <mf-tooltip max-width="280" bottom variant="secondary" :disabled="isSECAP">
                  <template #activator="{ on }">
                    <p class="mb-0" :class="isSECAP ? 'link' : 'disabled'" @click="handleGenerateWinner(item)">Gerar ganhador</p>
                  </template>
                  Não é possível utilizar essa opção em um sorteio sequencial
                </mf-tooltip>
              </td>
            </tr>
          </template>
        </raffle-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import RaffleTable from './RaffleTable.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import { DateTime } from 'luxon'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
export default {
  name: 'PrizesWinnersTable',
  components: {
    RaffleTable,
  },
  props: {
    linksClassList: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    prizeSearch: '',
    showTooltipPrizeTitle: {},
    prizesTableHeader: [
      {
        text: 'Nome',
        value: 'title',
        width: '25%',
        sortable: false,
      },
      {
        text: 'Data de sorteio',
        value: 'raffle_date',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Quantidade',
        value: 'quantity',
        width: '20%',
        sortable: false,
      },
      {
        text: 'Ganhadores registrados',
        value: 'registered_winners',
        width: '25%',
        sortable: false,
      },
      {
        text: '',
        value: '',
        sortable: false,
        width: '180px',
      },
      {
        text: '',
        value: '',
        sortable: false,
        width: '180px',
      },
    ],
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    hasPiiAccess() {
      return this.$hasPiiAccess()
    },
    raffleType() {
      return this.raffle.lucky_number_generation_type
    },
    isSECAP() {
      return this.raffleType === 'SECAP'
    },
  },
  methods: {
    handleGenerateWinner(item) {
      if (this.isSECAP) {
        this.$emit('generate-winner', item)
      }
    },
    prizeTransformFunction(item) {
      const updatedItem = { ...item }
      updatedItem.raffle_date = moment(updatedItem.raffle_date).format('DD/MM/YYYY')
      updatedItem.registered_winners = `${item.winners.length}/${updatedItem.quantity}`
      return updatedItem
    },
    prizeFilterItemsBySearch(item, search) {
      const searchRegex = diacriticSpaceSensitiveRegex(search)
      return item.title.match(searchRegex) || `${item.quantity}` === this.search
    },
    formatedDate(date) {
      return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  color: $cinza-0;
  cursor: not-allowed;
}

.blue-action-text {
  color: $marca-0-l40;
  text-decoration: underline;
  text-align: right;
  &:hover {
    cursor: pointer;
  }
}
.gray-disabled-text {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.216667px;
  text-decoration-line: underline;
  color: $cinza-l40;
}
</style>
